import React, { useState, useEffect } from 'react';
import { MdOutlineFilterList } from "react-icons/md";
import { FaFilter } from "react-icons/fa";
import { BiEdit } from "react-icons/bi";
import { Link } from "react-router-dom";
import './New.css';
import AlertMessage from "../../AlertMessage";


const CustomMenu = ({ checkboxes, isOpen }) => {
  return (
    <div className={`custom-menu1 ${isOpen ? 'open1' : ''}`}>
      <div className="row">
        <div className="col">
          <div className="collapse1 multi-collapse1" id="multiCollapseExample2">
            <div style={{ marginBottom: '0' }} className="card card-body open-card1">
              {checkboxes.map((checkbox, index) => (
                <label key={index}>
                  <input className='me-2'
                    type="checkbox"
                    checked={checkbox.checked}
                    onChange={checkbox.onChange}
                    style={{ width: 'auto' }}
                  />
                  {checkbox.label}
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const StudentAllData = () => {
  const [selectedGender, setSelectedGender] = useState('');
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedCaste, setSelectedCaste] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [students, setStudents] = useState([]);
  const [classOptions, setClassOptions] = useState([]);
  const [casteOptions, setCasteOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [showAdharNo, setShowAdharNo] = useState(false);
  const [showdateOfAdmission, setShowdateOfAdmission] = useState(false);
  const [showCountry, setShowCountry] = useState(false);
  const [showDistrict, setShowDistrict] = useState(false);
  const [showReligion, setShowReligion] = useState(false);
  const [showMobileNo, setShowMobileNo] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const [showTaluka, setShowTaluka] = useState(false);
  const [showDob, setShowDob] = useState(false);
  const [showRollNo, setShowRollNo] = useState(false);
  const [showMother, setShowMother] = useState(false);
  const [showBookNo, setShowBookNo] = useState(false);
  const [showSARALID, setShowSARALID] = useState(false);
  const [showRegisterNo, setShowRegisterNo] = useState(false);
  const [showPrevSchool, setShowPrevSchool] = useState(false);
  const [showState, setShowState] = useState(false);
  const [showHostel, setShowHostel] = useState(false);
  const [showScolar, setshowScolar] = useState(false);
  const [showPenNo, setShowPenNo] = useState(false);

  const [divisionOptions, setDivisionOptions] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState('');
  const [filterByDivision, setFilterByDivision] = useState(true);
  const [filterByGender, setFilterByGender] = useState(false);
  const [filterByClass, setFilterByClass] = useState(true);
  const [filterByCaste, setFilterByCaste] = useState(false);
  const [filterByCategory, setFilterByCategory] = useState(false);
  const [expandCheckboxes, setExpandCheckboxes] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const udiseNumber = localStorage.getItem("udiseNumber");
  const selectedStudentSerialNo = localStorage.getItem("selectedStudentSerialNo");
  const [selectedIsHosteller, setSelectedIsHosteller] = useState('');
  const [selectedIsScolar, setSelectedIsScolar] = useState('');
  const [studentFilter, setStudentFilter] = useState('active');
  const [filterByIsHosteller, setFilterByIsHosteller] = useState(false);
  const [filterByIsScolar, setFilterByIsScolar] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
const [showAddress, setShowAddress] = useState(false);
const [showCity, setShowCity] = useState(false);

  const [showApaarId, setShowApaarId] = useState(false);

  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);

const romanToInt = { I: 1,II: 2, III: 3,IV: 4, V: 5, VI: 6,VII: 7,VIII: 8, IX: 9, X: 10, XI: 11,XII: 12,};
const marathiToInt = {'पहिली': 1,'दुसरी': 2,'तिसरी': 3, 'चौथी': 4,'पाचवी': 5,'सहावी': 6,'सातवी': 7,'आठवी': 8,'नववी': 9,'दहावी': 10,'अकरावी': 11,'बारावी': 12 };

  const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');

  useEffect(() => {
    const storedLanguage = localStorage.getItem('language') || 'English';
    setLanguage(storedLanguage);
  }, []);

  const handleEllipsisClick = () => {
    setExpandCheckboxes(!expandCheckboxes);
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (udiseNumber) {
      fetchAllCaste();
      fetchAllCategory();
    }
  }, [udiseNumber]);

  useEffect(() => {
    fetchDataByFilters();
  }, [filterByGender, filterByCaste, filterByCategory, filterByClass, filterByDivision, filterByIsHosteller, filterByIsScolar, selectedGender, selectedCaste, selectedCategory, selectedClass, selectedDivision, selectedIsHosteller, selectedIsScolar, udiseNumber]);

  const [classes, setClasses] = useState([]); // To hold class names
  const [divisions, setDivisions] = useState({}); // To hold divisions for each class

  const fetchClassDivData = async () => {
    try {
      const storedDivClasses = localStorage.getItem("classDiv");
      if (storedDivClasses) {
        const data = JSON.parse(storedDivClasses);
        const classList = [];
        const divisionList = {};
        for (const [className, value] of Object.entries(data)) {
          if (value === true) {
            // Class without divisions
            classList.push(className);
            divisionList[className] = []; // Initialize with an empty array
          } else if (typeof value === 'object') {
            // Class with divisions
            classList.push(className);
            divisionList[className] = Object.keys(value).filter(div => value[div]); // Get divisions that are true
          }
        }
        setClasses(classList);
        setDivisions(divisionList); // Set the divisionList as the state
      }
    } catch (error) {
      console.error("Error fetching classDiv data: ", error);
    }
  };

  const allDivisions = Array.from(new Set(Object.values(divisions).flat()));

  useEffect(() => {
    debugIndexedDB();
    fetchClassDivData();
  }, [udiseNumber]);

  // Function to open IndexedDB and get student data
  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1);
      request.onerror = (event) => {
        console.error('Database error:', event.target.error);
        reject('Error opening IndexedDB');
      };
      request.onsuccess = (event) => {
        resolve(event.target.result);
      };
      // If the database doesn't exist yet, create it
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('studentData')) {
          db.createObjectStore('studentData', { keyPath: 'id' });
        }
      };
    });
  };

  const debugIndexedDB = async () => {
    try {
      console.log("Starting IndexedDB debug...");
      const db = await openIndexedDB();
      const transaction = db.transaction(['studentData'], 'readonly');
      const objectStore = transaction.objectStore('studentData');
      const allRecords = objectStore.getAll();
      allRecords.onsuccess = (event) => {
        const data = event.target.result;
        console.log("All records from IndexedDB:", data);
        console.log("Number of records:", data.length);
        // Log the structure of the first record
        if (data.length > 0) {
          console.log("First record structure:", data[0]);
          console.log("Keys in first record:", Object.keys(data[0]));
        }
      };
      // Also log all object store names
      console.log("Object store names:", Array.from(db.objectStoreNames));
    } catch (error) {
      console.error("Debug error:", error);
    }
  };


  const fetchAllCaste = async () => {
    try {
      const db = await openIndexedDB();
      const transaction = db.transaction(['studentData'], 'readonly');
      const objectStore = transaction.objectStore('studentData');
      const allRecords = objectStore.getAll();
      allRecords.onsuccess = (event) => {
        const studentsData = event.target.result;
        // Extract unique castes
        const castesSet = new Set(
          studentsData
            .filter(student => student !== null && typeof student === 'object')
            .map(student => student.caste)
        );
        setCasteOptions(Array.from(castesSet));
      };
      allRecords.onerror = (event) => {
        console.error('Error fetching castes from IndexedDB:', event.target.error);
      };
    } catch (error) {
      console.error('Error in fetchAllCaste:', error);
    }
  };

   const fetchAllCategory = async () => {
    try {
      const db = await openIndexedDB();
      const transaction = db.transaction(['studentData'], 'readonly');
      const objectStore = transaction.objectStore('studentData');
      const allRecords = objectStore.getAll();
      allRecords.onsuccess = (event) => {
        const studentsData = event.target.result;
        // Extract unique categories
        const categoriesSet = new Set(
          studentsData
            .filter(student => student !== null && typeof student === 'object')
            .map(student => student.category)
        );
        setCategoryOptions(Array.from(categoriesSet));
      };
      allRecords.onerror = (event) => {
        console.error('Error fetching categories from IndexedDB:', event.target.error);
      };
    } catch (error) {
      console.error('Error in fetchAllCategory:', error);
    }
  };
  const fetchDataByFilters = async () => {
    try {
      console.log("Fetching data with filters...");
      const db = await openIndexedDB();
      const transaction = db.transaction(['studentData'], 'readonly');
      const objectStore = transaction.objectStore('studentData');
      const allRecords = objectStore.getAll();
      allRecords.onsuccess = (event) => {
        const records = event.target.result;
        console.log("Records retrieved:", records);
        // Create a flat array of all students
        let allStudents = [];
        records.forEach(record => {
          // Check if the record is an array (containing students)
          if (Array.isArray(record)) {
            // Add all students from the array
            allStudents = allStudents.concat(record.filter(student =>
              student && typeof student === 'object'));
          }
          // Check if this is a student object directly
          else if (record && typeof record === 'object' && record.serialNo) {
            allStudents.push(record);
          }
          // Handle case where students might be nested in a different structure
          else if (record && typeof record === 'object') {
            // Check for properties that might contain student arrays
            Object.keys(record).forEach(key => {
              if (Array.isArray(record[key])) {
                allStudents = allStudents.concat(record[key].filter(student =>
                  student && typeof student === 'object'));
              }
            });
          }
        });

        console.log("Extracted students before filtering:", allStudents.length);

        // Apply filters based on selected values
        let filteredData = allStudents;

        if (filterByGender && selectedGender !== '') {
          filteredData = filteredData.filter(student => student.gender === selectedGender);
        }
        if (filterByCaste && selectedCaste !== '') {
          filteredData = filteredData.filter(student => student.caste === selectedCaste);
        } 
        if (filterByCategory && selectedCategory !== '') {
          filteredData = filteredData.filter(student => student.category === selectedCategory);
        }
        if (filterByClass && selectedClass !== '') {
          filteredData = filteredData.filter(student => student.currentClass === selectedClass);
        }
        if (filterByDivision && selectedDivision !== '') {
          filteredData = filteredData.filter(student => student.division === selectedDivision);
        }
        if (filterByIsHosteller && selectedIsHosteller !== '') {
          if (selectedIsHosteller === 'Boarder') {
            filteredData = filteredData.filter(student => student.isHosteller === "true");
          } else if (selectedIsHosteller === 'Non-Boarder') {
            filteredData = filteredData.filter(student => student.isHosteller === "false");
          }
        }

        if (filterByIsScolar && selectedIsScolar !== '') {
          if (selectedIsScolar === 'Scolar') {
            filteredData = filteredData.filter(student => student.isScolar === "true");
          } else if (selectedIsScolar === 'Non-Scolar') {
            filteredData = filteredData.filter(student => student.isScolar === "false");
          }
        }
        console.log("Filtered students:", filteredData.length);
        setStudents(filteredData);
      };

      allRecords.onerror = (event) => {
        console.error('Error fetching student data from IndexedDB:', event.target.error);
      };
    } catch (error) {
      console.error('Error in fetchDataByFilters:', error);
    }
  };



  const handleIsHostellerChange = (event) => {
    const value = event.target.value;
    setSelectedIsHosteller(value);
    setFilterByIsHosteller(value !== ""); // Set filter status based on selection
  };

  const handleIsScolarChange = (event) => {
    const value = event.target.value;
    setSelectedIsScolar(value);
    setFilterByIsScolar(value !== ""); // Set filter status based on selection
  };

  const handleGenderChange = (event) => { setSelectedGender(event.target.value);};
  const handleClassChange = (event) => { setSelectedClass(event.target.value);};
  const handleCasteChange = (event) => { setSelectedCaste(event.target.value); };
  const handleCategoryChange = (event) => { setSelectedCategory(event.target.value); };
  const handleDivisionChange = (event) => { setSelectedDivision(event.target.value);};
  const handleClearData = () => { window.location.reload(); };

  const handlePrint = () => {
    const printContent = document.querySelector('.table-responsive'); // Adjust selector to match your layout
    removeLastColumnOnPrint();
    if (printContent) {
      const cloneContent = printContent.cloneNode(true); // Clone the main content
      // Open a new window for printing
      const printWindow = window.open('', '', 'height=800,width=1000');

      printWindow.document.write(`
        <html>
          <head>
            <style>
              @page {
                size: A4 landscape;
                margin: 3mm;
                padding: 15px;
                border: 1px solid black;
              }
              body {
                font-family: Arial, sans-serif;
                margin: 0;
                padding: 0;
              }
              table {
                border-collapse: collapse;
                width: 100%;
                font-size: 16px;
              }
              th, td {
                border: 1px solid black;
                text-align: center;
                padding: 5px;
              }
              td {
                font-size: 16px;
              }
              th {
                background-color: #82CAFA;
              }
              .print-button {
                display: none;
              }
              .school-header-container {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
              }
              .school-header2 {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                flex: 0 0 auto; /* Prevent this section from growing */
                margin-right: 10px;
              }
              .school-header2 img {
                max-height: 70px;
              }
              .school-header {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                text-align: center; margin-left:-70px;
                flex: 1 1 auto; /* This makes the school header take available space */
              }
              .school-header h1 {
                font-size: 28px;
                margin: 5px 0;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .school-header .report-title {
                font-size: 20px;
                margin: 5px auto;
                font-weight: bold;
                border: 1px solid black;
                width: 200px;
                padding: 5px;
                text-align: center;
                border-radius: 10px;
                background-color: black;
                color: white;
              }
              .school-header .report-tit {
                font-size: 16px;
                margin: 5px auto;
                font-weight: bold;
                text-align: center;
              }
            </style>
          </head>
          <body>
            <div class="school-header-container">
              <div class="school-header2">
                ${logoURL ? `<img src="${logoURL}" alt="School Logo" onload="window.print()">` : '<div></div>'}
              </div>
              <div class="school-header">
                <div style="margin-left: 15px;">
                  <h1>${schoolData ? schoolData.schoolName : " "}</h1>
                  <div class="report-tit">
                    ${language === 'English' ? 'Taluka' : 'तालुका'} ${schoolData ? schoolData.taluka : " "} , ${language === 'English' ? 'District' : 'जिल्हा'} : ${schoolData ? schoolData.jilha : " "}
                  </div>
                  <div class="report-title">
                    ${language === "English" ? "Student Report" : "विद्यार्थी अहवाल"}
                  </div>
                </div>
              </div>
            </div>
            <style>
              .styled-table {
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
              }
            </style>
            ${cloneContent.outerHTML}
          </body>
        </html>
`);

      printWindow.document.close();
      appendLastColumnOnPrint();

      // Focus and print the window after the image is loaded
      if (logoURL) {
        const img = printWindow.document.querySelector('.school-header2 img');
        img.onload = () => {
          printWindow.focus();
          printWindow.print();
          printWindow.close();
        };
      } else {

        printWindow.focus();
        printWindow.print();
        printWindow.close();
      }
    } else {
      console.error('Content to print not found');
    }
  };

  function removeLastColumnOnPrint() {
    const table = document.querySelector('.table');
    const thead = table.querySelector('thead');
    const tbody = table.querySelector('tbody');

    const lastHeader = thead.querySelector('tr th:last-child');
    if (lastHeader) {
      lastHeader.style.display = 'none';
    }
    tbody.querySelectorAll('tr').forEach(row => {
      const lastCell = row.querySelector('td:last-child');
      if (lastCell) {
        lastCell.style.display = 'none';
      }
    });
  }

  function appendLastColumnOnPrint() {
    const table = document.querySelector('.table');
    const thead = table.querySelector('thead');
    const tbody = table.querySelector('tbody');

    const lastHeader = thead.querySelector('tr th:last-child');
    if (lastHeader) {
      lastHeader.style.display = '';
    }

    tbody.querySelectorAll('tr').forEach(row => {
      const lastCell = row.querySelector('td:last-child');
      if (lastCell) {
        lastCell.style.display = '';
      }
    });
  }
  const translations = {
    English: {
      division: 'Division',
      gender: 'Gender',
      adharNo: 'Adhar No',
      dateOfAdmission: 'Admission Date',
      country: 'Country',
      district: 'District',
      class: 'Class',
      caste: 'Caste',
      taluka: 'Taluka',
      dob: 'Dob',
      rollNo: 'Roll No',
      stdMother: 'Mothers Name',
      religion: 'Religion',
      mobileNo: 'MobileNo',
      category: 'Category',
      email: 'Email',
      SARALID: 'SARAL ID',
      registerNo: 'Register No',
      prevSchool: 'Previous School',
      state: 'State',
      bookNo: 'Book No',
      isHosteller: 'Boarder/Resident Student?',
      isScolar: 'Scholarship?',
      penNo: 'PEN No',
      aparId: 'APAR ID',
        address: 'Address',
        city: 'City',
    },
    Marathi: {
      division: 'तुकडी',
      gender: 'लिंग',
      adharNo: 'आधार क्र',
      dateOfAdmission: 'प्रवेशाची तारीख',
      country: 'देश',
      district: 'जिल्हा',
      class: 'वर्ग',
      caste: 'जात',
      taluka: 'तालुका',
      dob: 'जन्मतारीख',
      rollNo: 'हजेरी क्र.',
      stdMother: 'आईचे नाव',
      religion: 'धर्म',
      mobileNo: 'मोबाईल नं.',
      category: 'श्रेणी',
      email: 'ईमेल आयडी',
      SARALID: 'सरल आयडी',
      registerNo: 'रजिस्टर क्र.',
      prevSchool: 'मागील शाळा',
      state: 'राज्य',
      bookNo: 'पुस्तक क्र.',
      isHosteller: 'बोर्डर/निवासी विद्यार्थी?',
      isScolar: 'शिष्यवृत्ती?',
      penNo: 'PEN No',
      aparId: 'अपार आयडी',
 address: 'पत्ता',
 city: 'शहर',
    },
  };

  const checkboxes = [

    {
  label: translations[language].address,
  checked: showAddress,
  onChange: () => handleCheckboxChange(setShowAddress, showAddress),
},

 {
  label: translations[language].city,
  checked: showCity,
  onChange: () => handleCheckboxChange(setShowCity, showCity),
},

 {
      label: translations[language].class,
      checked: filterByClass,
      onChange: () => handleCheckboxChange(setFilterByClass, filterByClass),
    },

    {
      label: translations[language].division,
      checked: filterByDivision,
      onChange: () => handleCheckboxChange(setFilterByDivision, filterByDivision),
    },
    {
      label: translations[language].gender,
      checked: filterByGender,
      onChange: () => handleCheckboxChange(setFilterByGender, filterByGender),
    },
    {
      label: translations[language].caste,
      checked: filterByCaste,
      onChange: () => handleCheckboxChange(setFilterByCaste, filterByCaste),
    },
   
    {
      label: translations[language].category,
      checked: filterByCategory,
      onChange: () => handleCheckboxChange(setFilterByCategory, filterByCategory),
    },
    
    {
      label: translations[language].adharNo,
      checked: showAdharNo,
      onChange: () => handleCheckboxChange(setShowAdharNo, showAdharNo),
    },
    {
      label: translations[language].dateOfAdmission,
      checked: showdateOfAdmission,
      onChange: () => handleCheckboxChange(setShowdateOfAdmission, showdateOfAdmission),
    },
    {
      label: translations[language].country,
      checked: showCountry,
      onChange: () => handleCheckboxChange(setShowCountry, showCountry),
    },
    {
      label: translations[language].district,
      checked: showDistrict,
      onChange: () => handleCheckboxChange(setShowDistrict, showDistrict),
    },
    {
      label: translations[language].taluka,
      checked: showTaluka,
      onChange: () => handleCheckboxChange(setShowTaluka, showTaluka),
    },
    {
      label: translations[language].dob,
      checked: showDob,
      onChange: () => handleCheckboxChange(setShowDob, showDob),
    },
     {
      label: translations[language].rollNo,
      checked: showRollNo,
      onChange: () => handleCheckboxChange(setShowRollNo, showRollNo),
    },
    {
      label: translations[language].stdMother,
      checked: showMother,
      onChange: () => handleCheckboxChange(setShowMother, showMother),
    },
    {
      label: translations[language].religion,
      checked: showReligion,
      onChange: () => handleCheckboxChange(setShowReligion, showReligion),
    },
    {
      label: translations[language].mobileNo,
      checked: showMobileNo,
      onChange: () => handleCheckboxChange(setShowMobileNo, showMobileNo),
    },
    {
      label: translations[language].email,
      checked: showEmail,
      onChange: () => handleCheckboxChange(setShowEmail, showEmail),
    },
    {
      label: translations[language].SARALID,
      checked: showSARALID,
      onChange: () => handleCheckboxChange(setShowSARALID, showSARALID),
    },
    {
      label: translations[language].registerNo,
      checked: showRegisterNo,
      onChange: () => handleCheckboxChange(setShowRegisterNo, showRegisterNo),
    },
    {
      label: translations[language].prevSchool,
      checked: showPrevSchool,
      onChange: () => handleCheckboxChange(setShowPrevSchool, showPrevSchool),

    },
    {
      label: translations[language].state,
      checked: showState,
      onChange: () => handleCheckboxChange(setShowState, showState),
    },
    {
      label: translations[language].isHosteller,
      checked: showHostel,
      onChange: () => handleCheckboxChange(setShowHostel, showHostel),
    },
    {
      label: translations[language].isScolar,
      checked: showScolar,
      onChange: () => handleCheckboxChange(setshowScolar, showScolar),
    },
    {
      label: translations[language].penNo,
      checked: showPenNo,
      onChange: () => handleCheckboxChange(setShowPenNo, showPenNo),
    },
     {
    label: "APAAR ID",
    checked: showApaarId,
    onChange: () => handleCheckboxChange(setShowApaarId, showApaarId),
  },
  ];
  const [selectedCheckboxCount, setSelectedCheckboxCount] = useState(0);

  const handleCheckboxChange = (setCheckboxState, currentCheckboxState) => {
    if (currentCheckboxState) {
      setCheckboxState(false);
      setSelectedCheckboxCount(selectedCheckboxCount - 1);
    } else {
      setCheckboxState(true);
      setSelectedCheckboxCount(selectedCheckboxCount + 1);

      if (selectedCheckboxCount >= 6) {
        setAlertMessage("You have already selected  more than 6 fields. Selecting more may cause issues with printing.");
      }
    }
  };


  const [logoURL, setLogoURL] = useState(null);

  const [schoolData, setSchoolData] = useState(null);

  const handleFilterChange = (event) => {
    setStudentFilter(event.target.value);
  };
  const fetchSchoolData = async () => {
    if (udiseNumber) {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['schoolData'], 'readonly');
        const objectStore = transaction.objectStore('schoolData');
        const request = objectStore.get(udiseNumber);

        request.onsuccess = (event) => {
          const data = event.target.result;
          if (data) {
            setSchoolData(data);
            setLogoURL(data.schoolLogo); // Set the logo URL
          }
        };

        request.onerror = (event) => {
          console.error("Error fetching school data:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching school data:', error);
      }
    }
  };

  useEffect(() => {
    fetchSchoolData();
  }, [udiseNumber]);

  const trimSpaces = (str) => {
    if (typeof str === 'string') {
      return str.trim();
    }
    return str;
  };

  const getUniqueClassOptions = (options) => {
    const trimmedOptions = options.map(trimSpaces);
    return Array.from(new Set(trimmedOptions)).filter(cls => cls !== "");
  };
  const formatDate = (dateString) => {
    if (!dateString) return ''; // Return empty if no date is provided
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with zero if needed
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-indexed) and pad with zero
    const year = date.getFullYear(); // Get full year
    return `${day}-${month}-${year}`; // Return formatted date
  };


  useEffect(() => {
    // Clear previous students data when serial number changes
    setStudents([]);

    if (selectedStudentSerialNo) {
      fetchStudentBySerialNo();
    } else {
      fetchDataByFilters();
    }
  }, [selectedStudentSerialNo, udiseNumber]);

  const fetchStudentBySerialNo = async () => {
    try {
      console.log("Fetching student with serialNo:", selectedStudentSerialNo);

      const db = await openIndexedDB();
      const transaction = db.transaction(['studentData'], 'readonly');
      const objectStore = transaction.objectStore('studentData');
      const allRecords = objectStore.getAll();

      allRecords.onsuccess = (event) => {
        const records = event.target.result;
        console.log("All records from IndexedDB:", records);

        let allStudents = [];

        records.forEach(record => {
          // Handle array of students
          if (Array.isArray(record)) {
            allStudents = allStudents.concat(record.filter(student =>
              student && typeof student === 'object' && student.serialNo
            ));
          }
          // Handle single student object
          else if (record && typeof record === 'object' && record.serialNo) {
            allStudents.push(record);
          }
          // Handle nested student arrays
          else if (record && typeof record === 'object') {
            Object.values(record).forEach(value => {
              if (Array.isArray(value)) {
                allStudents = allStudents.concat(value.filter(student =>
                  student && typeof student === 'object' && student.serialNo
                ));
              }
            });
          }
        });

        console.log("Extracted students:", allStudents);

        // Ensure serialNo comparison handles type differences
        const matchingStudent = allStudents.find(student =>
          String(student.serialNo) === String(selectedStudentSerialNo)
        );

        console.log("Matching student:", matchingStudent);

        if (matchingStudent) {
          setStudents([matchingStudent]);
        } else {
          setStudents([]);
          setAlertMessage("No student found.");
        }
      };

      allRecords.onerror = (event) => {
        console.error('Error fetching student data from:', event.target.error);
        setAlertMessage("Error fetching student data.");
      };
    } catch (error) {
      console.error('Error in fetchStudentBySerialNo:', error);
      setAlertMessage("Error fetching student data.");
    }
  };


  return (
    <div>
      <AlertMessage message={alertMessage} show={showAlert} />
      <div className="mb-5 main-content-of-page">
        <div style={{ width: '140px', float: 'right' }}>
          <label htmlFor="studentFilter" style={{ marginRight: '10px' }}>

          </label>
          <select id="studentFilter" value={studentFilter} onChange={handleFilterChange} className="dropdown">
            <option value="active">Active Students</option>
            <option value="inactive">Inactive Students</option>
            <option value="all">All Students</option>
          </select>
        </div>

        <style>
          {`
            @media print {
              .table th,
              .table td {
                background-color: transparent !important;
                -webkit-print-color-adjust: exact;
              }
              .bg-secondary {
                background-color: transparent !important;
              }
              .print-button {
                display: none;
              }
              .custom-heading-text{
                margin: -5px auto;
              }
            
            }
          `}
        </style>
        <center
          style={{
            borderBottom: "0.5px solid gray",
            padding: "-10px",
            marginBottom: "20px",
          }}
        >
          <div
            id="print-title"
            className="text-center"
            style={{ marginTop: "10px", fontWeight: "bold" }}
          ></div>
          <div
            className="custom-heading"
            style={{ paddingBottom: "-20px", marginTop: "-10px" }}
          >
            <h3
              className="text-center mb-2"
              style={{ color: "#03365e", fontWeight: "600" }}
            >
              {language === "English" ? "Student Report" : "विद्यार्थी अहवाल"}
            </h3>
          </div>
        </center>

        <div
          className="filter-container "
          style={{
            position: "relative",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            marginLeft: "10px",
          }}
        >
          <div
            onClick={handleEllipsisClick}
            style={{ position: "absolute", left: 0 }}
          >
            <button
              className="btn btn-primary filterbtn1"
              type="button"
              data-toggle="collapse"
              data-target="#multiCollapseExample2"
              aria-expanded="false"
              aria-controls="multiCollapseExample2"
            >
              <FaFilter />
            </button>
          </div>
          {expandCheckboxes && (
            <CustomMenu checkboxes={checkboxes} isOpen={isOpen} />
          )}
          <div>
            <label htmlFor="classDropdown">
              {language === "English" ? "Select Class" : "वर्ग निवडा"}
            </label>
            <select
              id="classDropdown"
              value={selectedClass}
              onChange={handleClassChange}
              className="dropdown"
            >
              <option value="" >
                {language === "English" ? "Select" : "निवडा"}
              </option>
              {getUniqueClassOptions(classes)
                .filter(
                  (cls) => cls !== null && cls !== undefined && cls !== ""
                ) // Filter out null and undefined classes
                .sort((a, b) => {
                  const classA = a.split(" ")[1];
                  const classB = b.split(" ")[1];
                  let numA, numB;

                  if (language === "English") {
                    numA =
                      romanToInt[classA] !== undefined ? romanToInt[classA] : 0; // Default to 0 if not found
                    numB =
                      romanToInt[classB] !== undefined ? romanToInt[classB] : 0; // Default to 0 if not found
                  } else {
                    numA =
                      marathiToInt[classA] !== undefined
                        ? marathiToInt[classA]
                        : 0; // Default to 0 if not found
                    numB =
                      marathiToInt[classB] !== undefined
                        ? marathiToInt[classB]
                        : 0; // Default to 0 if not found
                  }

                  return numA - numB; // Sort based on the numerical value
                })
                .map((cls, index) => (
                  <option key={index} value={cls}>
                    {cls}
                  </option>
                ))}
            </select>
          </div>
          <div>
            <label htmlFor="divisionDropdown">
              {language === "English" ? "Select Division" : "तुकडी"}
            </label>
            <select
              id="divisionDropdown"
              value={selectedDivision}
              onChange={handleDivisionChange}
              className="dropdown"
            >
              <option value="" >
                {language === "English" ? "Select" : "निवडा"}
              </option>
              {[
                ...new Set(
                  allDivisions.filter(
                    (option) =>
                      option !== null && option !== undefined && option !== ""
                  )
                ),
              ]
                .sort((a, b) => a.localeCompare(b))
                .map((option, index) => (
                  <option key={index} value={option}>
                    {option}
                  </option>
                ))}
            </select>
          </div>

          <div
            className="filter-icon"
            onClick={() => setShowFilters(!showFilters)}
          >
            <MdOutlineFilterList />
          </div>
          {showFilters && (
            <div className="filter-panel" style={{ boxShadow: '0 0px 8px rgba(0,0,0,0.5)' }}>
              <div className="filter-options">
                <label htmlFor="gender" style={{ fontSize: '15px', marginBottom: '-5px' }}>
                  {language === "English" ? "Select Gender" : "लिंग निवडा"}
                </label>
                <select
                  id="gender" style={{ height: '35px', padding: '5px', fontSize: '14px' }}
                  value={selectedGender}
                  onChange={handleGenderChange}
                >
                  <option value="" >
                    {language === "English" ? "Select" : "निवडा"}
                  </option>
                  <option value="male">
                    {language === "English" ? "Male" : "मुलगा"}
                  </option>
                  <option value="female">
                    {language === "English" ? "Female" : "मुलगी"}
                  </option>
                </select>
              </div>

              <hr />
              <div className="filter-options">
                <label htmlFor="Caste" style={{ fontSize: '15px', marginBottom: '-5px' }}>
                  {language === "English" ? "Select Caste" : "जात निवडा"}
                </label>
                <select
                  id="Caste" style={{ height: '35px', padding: '5px', fontSize: '14px' }}
                  value={selectedCaste}
                  onChange={handleCasteChange}
                >
                  <option value="" >
                    {language === "English" ? "Select" : "निवडा"}
                  </option>
                  {casteOptions
                    .filter(option => option !== null && option !== undefined && option !== "")
                    .map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                </select>
              </div>
              <hr/>
               <div className="filter-options">
                <label htmlFor="Category" style={{ fontSize: '15px', marginBottom: '-5px' }}>
                  {language === "English" ? "Select Category" : "श्रेणी निवडा"}
                </label>
                <select
                  id="Category" style={{ height: '35px', padding: '5px', fontSize: '14px' }}
                  value={selectedCategory}
                  onChange={handleCategoryChange}
                >
                  <option value="" >
                    {language === "English" ? "Select" : "निवडा"}
                  </option>
                  {categoryOptions
                    .filter(option => option !== null && option !== undefined && option !== "")
                    .map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                </select>
              </div>
              <hr />
              <div className="filter-options">
                <label htmlFor="isHosteller" style={{ fontSize: '15px', marginBottom: '-5px' }}>
                  {language === "English" ? "Boarder/Resident Student?" : "बोर्डर/निवासी विद्यार्थी?"}
                </label>
                <select
                  style={{ height: '35px', padding: '5px', fontSize: '14px' }}
                  id="isHosteller"
                  value={selectedIsHosteller}
                  onChange={handleIsHostellerChange}>
                  <option value="">
                    {language === "English" ? "Select" : "निवडा"}
                  </option>
                  <option value="Boarder">
                    {language === "English" ? "Boarder/Resident" : "बोर्डर/निवासी विद्यार्थी"}
                  </option>
                  <option value="Non-Boarder">
                    {language === "English" ? "Non-Boarder/Non-Resident" : "नॉन-बोर्डर/अनिवासी विद्यार्थी"}
                  </option>
                </select>
              </div>
              <hr />

              <div className="filter-options">
                <label htmlFor="isScolar" style={{ fontSize: '15px', marginBottom: '-5px' }}>
                  {language === "English" ? "Scholarship?" : "शिष्यवृत्ती?"}
                </label>

                <select
                  id="isScolar" style={{ height: '35px', padding: '5px', fontSize: '14px' }}
                  value={selectedIsScolar}
                  onChange={handleIsScolarChange}>
                  <option value="">
                    {language === "English" ? "Select" : "निवडा"}
                  </option>
                  <option value="Scolar">
                    {language === "English" ? "Scholar" : "शिष्यवृत्ती असणारे"}
                  </option>
                  <option value="Non-Scolar">
                    {language === "English" ? "Non-Scholar" : "शिष्यवृत्ती नसणारे"}
                  </option>
                </select>
              </div>
            </div>
          )}

          <div style={{ position: "relative" }}>
            <button onClick={handlePrint} className="btn btn-primary">
              Print
            </button>
            <button onClick={handleClearData} className="clear-button">
              Clear Data
            </button>
          </div>
        </div>


        <div className="table-responsive mt-3">
          <table className="table table-bordered table-hover">
            <thead
              className="thead-dark"
              style={{ backgroundColor: "#82CAFA" }}
            >
              <tr>
                <th style={{ width: "5%" }}>
                  {language === "English" ? "Sr.No" : "अनु क्र."}
                </th>
                   {showRollNo && (
                  <th>{language === "English" ? "Roll No" : "हजेरी क्र."}</th>
                )}


                <th>{language === "English" ? "Name" : "नाव"}</th>
               
               {showAddress && (
                  <th>{language === "English" ? "Address" : "पत्ता"}</th>
                )}
                {showCity && (
                  <th>{language === "English" ? "City" : "शहर"}</th>
                )}
                {filterByClass && (
                  <th>{language === "English" ? "Class" : "वर्ग"}</th>
                )}
                {filterByDivision && (
                  <th>{language === "English" ? "Division" : "तुकडी"}</th>
                )}
                {filterByGender && (
                  <th>{language === "English" ? "Gender" : "लिंग"}</th>
                )}
                {showAdharNo && (
                  <th>{language === "English" ? "Adhar No" : "आधार क्र."}</th>
                )}
                {showdateOfAdmission && (
                  <th>{language === "English" ? "Admission Date" : "प्रवेशाची तारीख"}</th>
                )}
                {showCountry && (
                  <th>{language === "English" ? "Country" : "देश"}</th>
                )}
                {showState && (
                  <th>{language === "English" ? "State" : "राज्य"}</th>
                )}
                {showDistrict && (
                  <th>{language === "English" ? "District" : "जिल्हा"}</th>
                )}
                {showTaluka && (
                  <th>{language === "English" ? "Taluka " : "तालुका"}</th>
                )}
                {filterByCaste && (
                  <th>{language === "English" ? "Caste" : "जात"}</th>
                )}
                {filterByCategory && (
                  <th>{language === "English" ? "Category" : "श्रेणी"}</th>
                )}
                {showReligion && (
                  <th>{language === "English" ? "Religion " : "धर्म"}</th>
                )}
                {showMobileNo && (
                  <th>{language === "English" ? "MobileNo " : "मोबाईल नं."}</th>
                )} 
                {showEmail && (
                  <th>{language === "English" ? "Email" : "ईमेल आयडी"}</th>
                )}
                {showDob && (
                  <th>{language === "English" ? "Dob" : "जन्मतारीख"}</th>
                )}
             
                {showMother && (
                  <th>{language === "English" ? "Mothers Name" : "आईचे नाव"}</th>
                )}
                {showBookNo && (
                  <th>{language === "English" ? "BookNo " : "पुस्तक क्र."}</th>
                )}
                {showSARALID && (
                  <th>{language === "English" ? "SARALID" : "सरल आयडी"}</th>
                )}
                {showRegisterNo && (
                  <th>
                    {language === "English" ? "RegisterNo " : "रजिस्टर क्र."}
                  </th>
                )}
                {showPrevSchool && (
                  <th>
                    {language === "English" ? "PrevSchool" : "मागील शाळा"}
                  </th>
                )}
                {showHostel && (
                  <th>
                    {language === "English"
                      ? "Boarder/Resident Student?"
                      : "बोर्डर/निवासी विद्यार्थी?"}
                  </th>
                )}

                {showScolar && (
                  <th>
                    {language === "English"
                      ? "Scholarship?"
                      : "शिष्यवृत्ती?"}
                  </th>
                )}

                {showPenNo && (
                  <th>{language === "English" ? "PEN No" : "PEN No"}</th>
                )}

                 {showApaarId && (
      <th>{language === "English" ? "APAAR ID" : "अपार आयडी"}</th>
    )}
   

                <th id="editcolumn1">
                  {language === "English" ? "Edit" : "सुधारणे"}
                </th>
              </tr>
            </thead>
            <tbody>
              {students
                .filter(student => {
                  console.log("studentFilter", studentFilter);
                  // Check if the student is active or inactive based on the filter
                  if (studentFilter === 'active') return student.isActive !== false; // Active if isActive is not false
                  if (studentFilter === 'inactive') return student.isActive === false; // Inactive if isActive is explicitly false
                  return true; // Show all if no filter is applied
                })
                .map((student, index) => (
                  <tr key={student.id} style={{ backgroundColor: student.isActive !== false ? 'white' : 'rgb(233 119 119 / 21%)' }}> {/* Light red for inactive */}
                    <td>{index + 1}</td>
                         {showRollNo && <td>{student.rollNo}</td>}
                    <td>
                      {student.stdName} {student.stdFather} {student.stdSurname}
                    </td>
                    {showAddress && <td>{student.address}</td>}
                    {showCity && <td>{student.city}</td>}
                    {filterByClass && <td>{student.currentClass}</td>}
                    {filterByDivision && <td>{student.division}</td>}
                    {filterByGender && <td>{student.gender}</td>}
                    {showAdharNo && <td>{student.stdAdharNo}</td>}
                    {showdateOfAdmission && <td>{formatDate(student.dateOfAdmission)}</td>}
                    {showCountry && <td>{student.country}</td>}
                    {showState && <td>{student.state}</td>}
                    {showDistrict && <td>{student.district}</td>}
                    {showTaluka && <td>{student.taluka}</td>}
                    {filterByCaste && <td>{student.caste}</td>}
                    {filterByCategory && <td>{student.category}</td>}
                    {showReligion && <td>{student.religion}</td>}
                    {showMobileNo && <td>{student.mobileNo}</td>}
                    {showEmail && <td>{student.stdemailId}</td>}
                    {showDob && <td>{student.dob}</td>}
               
                    {showMother && <td>{student.stdMother}</td>}
                    {showBookNo && <td>{student.bookNo}</td>}
                    {showSARALID && <td>{student.studentId}</td>}
                    {showRegisterNo && <td>{student.registerNo}</td>}
                    {showPrevSchool && <td>{student.prevSchool}</td>}
                    {showHostel && (
                      <td>
                        {student.isHosteller === "true" ? (language === "English" ? "Yes" : "होय") : (language === "English" ? "No" : "नाही")}
                      </td>
                    )}
                    {showScolar && (
                      <td>
                        {student.isScolar === "true" ? (language === "English" ? "Yes" : "होय") : (language === "English" ? "No" : "नाही")}
                      </td>
                    )}
                    {showPenNo && <td>{student.panId}</td>}
                    {showApaarId && <td>{student.aparId}</td>}
       
                    <td id="editcolumn2">
                      <Link to={`/student-register/?serialNo=${student.serialNo}`}>
                        <BiEdit className="edit-icon" />
                      </Link>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default StudentAllData;